// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".share-btn[data-v-2c9e4864]{display:flex;align-items:center;vertical-align:middle}.share-btn .icon[data-v-2c9e4864]{font-size:24px;margin-right:2px}.share-modal[data-v-2c9e4864]{cursor:default}", ""]);
// Exports
module.exports = exports;
